<template>
    <div class="setting-store-index">
        <!-- 筛选 -->
        <el-form
            :model="form"
            label-width="100px"
            label-position="right"
            @submit.native.prevent="fetchData(1)"
            class="w-full flex flex-wrap items-center"
        >
            <el-form-item :label="$t('Store.Edit.store_name')" >
                <el-input v-model="form.name" :placeholder="$t('Store.enter_name_store')" class="w-full" clearable/>
            </el-form-item>
            <el-form-item :label="$t('Store.Edit.store_code')" >
                <el-input v-model="form.code" :placeholder="$t('Store.enter_code_store')" class="w-full" clearable/>
            </el-form-item>
            <el-form-item :label="$t('Store.Edit.store_phone')" >
                <el-input v-model="form.phone" :placeholder="$t('Store.enter_phone_store')" class="w-full" clearable/>
            </el-form-item>
            <template v-if="!is_collapse">
                <el-form-item :label="$t('Store.storeaddrs')" >
                <el-input v-model="form.address" :placeholder="$t('Store.enter_storeaddrs')" class="w-full" clearable/>
                </el-form-item>

                <el-form-item :label="$t('Store.Edit.operation_not')">
                <el-select v-model="form.trial" :placeholder="$t('Store.Edit.operation_not')" class="w-full" clearable>
                    <el-option :label="$t('Common.yes')" value="true"/>
                    <el-option :label="$t('Common.no')" value="false"/>
                </el-select>
                </el-form-item>
                <el-form-item :label="$t('Store.store_state')">
                <el-select v-model="form.active" :placeholder="$t('Store.store_state')" class="w-full" clearable>
                    <el-option :label="$t('Reception.Fifth.normal')" value="true"/>
                    <el-option :label="$t('Lesson.deleted')" value="false"/>
                </el-select>
                </el-form-item>
            </template>

            <el-form-item >
                <el-button type="primary" native-type="submit">{{ $t('Common.search') }}</el-button>
                <el-button @click="handleReset">{{ $t('Common.clear') }}</el-button>
            </el-form-item>
        </el-form>

        <div class="fitness-collapse mb-8 mt-2 text-xl flex items-center justify-between">
            <div class="line flex-1"/>
            <div class="mx-8 cursor-pointer" @click="is_collapse = !is_collapse">
                {{ is_collapse ? '高级搜索' : '收起' }}
                <i :class="is_collapse ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'"/>
            </div>
            <div class="line flex-1"/>
        </div>
        <!-- 搜索结果 -->
        <div style="font-size: 12px;">{{ message }}</div>
        <!-- 编辑 -->
        <div class="edit-store-icon">
            <el-tooltip effect="dark" :content="$t('Store.new_store')" placement="bottom">
                <el-button class=" el-button-ui iconfont icon-fitness-tianjiawenjian" @click="handleAdd" />
            </el-tooltip>
            <el-tooltip  effect="dark" :content="$t('tooltip.edit')" placement="bottom" >
                <el-button class="el-button-ui el-icon-edit" @click="handleEdit"/>
            </el-tooltip>
            <el-tooltip effect="dark" :content="$t('Store.CustomContractNumber')" placement="bottom">
                <el-button class="el-button-ui iconfont icon-fitness-jilu" @click="Contract" />
            </el-tooltip>
            <el-tooltip  effect="dark" :content="$t('Store.site_management')" placement="bottom">
                <el-button class="el-button-ui iconfont icon-fitness-changdiguanli" @click="place" />
            </el-tooltip>
            <el-tooltip effect="dark" :content="$t('tooltip.delete')" placement="bottom">
                <el-button class="el-button-ui iconfont icon-fitness-shanchu" @click="handleDelete" />
            </el-tooltip>
            <el-tooltip effect="dark" :content="$t('Store.Restore_stores')" placement="bottom"  >
                <el-button class="el-button-ui iconfont icon-fitness-huifu1" @click="handleRestore" />
            </el-tooltip>
        </div>
        <el-table
            border
            class="my-4"
            v-if="tableData"
            :data="tableData"
            v-loading="loading"
            highlight-current-row
            @current-change="handleCurrentChange">
            <el-table-column prop="name" :label="$t('Store.Edit.store_name')" align="center"/>
            <el-table-column prop="code" :label="$t('Store.Edit.store_code')" align="center"/>
            <el-table-column prop="phone" :label="$t('Common.phone')" align="center"/>
            <el-table-column prop="address" :label="$t('Client.address')" align="center"/>
            <el-table-column prop="email" :label="$t('Store.Edit.email')" align="center" width="120"/>
            <el-table-column prop="weight" :label="$t('Setting.SortDisplayWeight')" align="center"/>
            <el-table-column :label="$t('Store.Edit.operation_not')" align="center" width="120">
                <template slot="header" slot-scope="scope">
                    <span>{{ $t('Store.Edit.operation_not') }}</span>
                    <el-tooltip class="item" effect="dark" placement="bottom">
                        <div slot="content" class="store-tooltip-content">
                            <div>{{ $t('Store.Trial_operation') }}：</div>
                            <div>1、{{ $t('Lesson.mership_began') }}；</div>
                            <div>2、{{ $t('Lesson.nofirst_entry_card') }}；</div>
                            <div>3、{{ $t('Lesson.membership_subcards') }}；</div>
                            <div>4、{{ $t('Lesson.PrivateTeaching') }}；</div>
                        </div>
                        <span class="iconfont icon-fitness-help"></span>
                    </el-tooltip>
                </template>
                <template slot-scope="{$index, row}" v-if="row.trial !== ''">
                    {{ row.trial ? $t('Common.yes') : $t('Common.no') }}
                </template>
            </el-table-column>
            <el-table-column :label="$t('Store.store_state')" align="center" width="120">
                <template
                slot-scope="{$index, row}"
                v-if="row.active !== ''"
                >{{ row.active ? $t('Reception.Fifth.normal') : $t('Lesson.deleted') }}</template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
            v-if="tableData"
            class="text-right"
            @current-change="fetchData"
            :current-page.sync="pagination.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total"
        ></el-pagination>
    </div>
</template>

<script>

export default {
    components: {},
    data() {
        return {
            selectStore: {},
            message: '',
            loading: false,
            tableData: [],
            form: {
                name: '',
                code: '',
                id: '',
                phone: '',
                address: '',
                email: '',
                weight: '',
                trial: '',
                active: '',
            },
            pagination: {
                size: 10,
                total: 0,
                page: 1,
            },
            is_collapse: true,
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;

            API.get('/store/pages', {
                params: { ...this.form, ...this.pagination },
            }).then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
                this.message = `搜索结果：共${res.totalElements}家门店`;
            }).finally(() => {
                this.loading = false;
            });
        },
        handleReset() {
            this.form = {
                name: '',
                code: '',
                id: '',
                phone: '',
                address: '',
                email: '',
                weight: '',
                trial: '',
                active: '',
            };
            this.fetchData(1);
        },
        // 添加门店
        handleAdd() {
            if (!this.$$filterPermission('设置-场馆信息-场馆信息编辑'))
            return this.$router.push('/403');
            this.$router.push({ name: 'Store.Edit' });
        },
        // 编辑门店
        handleEdit() {
            if (this.validSelect()) {
                if (!this.$$filterPermission('设置-场馆信息-场馆信息编辑'))
                return this.$router.push('/403');
                this.$router.push({
                    name: 'Store.Edit',
                    params: { id: this.selectStore.id },
                });
            }
        },
        // 删除门店
        handleDelete() {
            if (this.validSelect()) {
                $ele.$confirm(this.$t('Message.confirmdel'), this.$t('Common.tip'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    cancelButtonText: this.$t('Common.cancel'),
                    type: 'warning',
                }).then(() => {
                    if (!this.$$filterPermission('设置-场馆信息-场馆信息编辑'))
                    return this.$router.push('/403');
                    API.delete(`store/${this.selectStore.id}/active`).then(() => {
                        $ele.$message.success(this.$t('Message.delete_success'));
                        this.fetchData(1);
                    });
                }).catch(() => {
                    $ele.$message.info(this.$t('Common.message.canceldel'));
                });
            }
        },
        // 回复门店
        handleRestore() {
            if (this.validSelect()) {
                $ele.$confirm(this.$t('Message.confirmrecord'), this.$t('Common.tip'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    cancelButtonText: this.$t('Common.cancel'),
                    type: 'warning',
                }).then(() => {
                    if (!this.$$filterPermission('设置-场馆信息-场馆信息编辑'))
                    return this.$router.push('/403');
                    API.put(`/store/${this.selectStore.id}/active`).then(() => {
                        $ele.$message.success(this.$t('Common.message.successRestore'));
                        this.fetchData(1);
                    });
                }).catch(() => {
                    $ele.$message.info(this.$t('Common.message.canceldel'));
                });
            }
        },
        // 自定义合同编号
        Contract() {
            if (this.validSelect()) {
                if (!this.$$filterPermission('设置-场馆信息-自动生成合同编号设置'))
                return this.$router.push('/403');
                this.$router.push({
                    name: 'Store.Contract',
                    params: { id: this.selectStore.id },
                });
            }
        },
        // 编辑门店场地
        place() {
            if (this.validSelect()) {
                if (!this.$$filterPermission('设置-场馆信息-场馆信息编辑'))
                return this.$router.push('/403');
                this.$router.push({
                    name: 'Store.Place',
                    params: { id: this.selectStore.id },
                });
            }
        },
        validSelect() {
            if (!this.selectStore || !this.selectStore.id) $ele.$message.warning(this.$t('Message.tip_one'));
            else return true;
        },
        handleCurrentChange(val) {
            this.selectStore = val;
        },
    },
};
</script>

<style lang="scss">
.setting-store-index {
    .store-tooltip-content {
        div {
            margin: 4px 0;
        }
    }
    .edit-store-icon {
        position: relative;
        float: right;
        margin-right: 1%;
        margin-top: 5px;
        margin-bottom: 10px;
    }
    .el-button-ui {
        border: none;
        line-height: 0;
        padding: 0px;
        margin-right: 0px;
        font-size: 19px;
        height: 20px;
    }
}
</style>
